import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

// Escuta os eventos de cada collapse para o rótulo acompanhar também a abertura
// bloco a bloco.
export default class extends Controller {
  static targets = ["bloco", "rotulo", "icone"];

  connect() {
    this.aoMudar = () => this.sincronizar();

    this.blocoTargets.forEach((bloco) => {
      bloco.addEventListener("shown.bs.collapse", this.aoMudar);
      bloco.addEventListener("hidden.bs.collapse", this.aoMudar);
    });

    this.sincronizar();
  }

  disconnect() {
    this.blocoTargets.forEach((bloco) => {
      bloco.removeEventListener("shown.bs.collapse", this.aoMudar);
      bloco.removeEventListener("hidden.bs.collapse", this.aoMudar);
    });
  }

  alternarTodos() {
    const abrir = !this.todosAbertos;

    this.blocoTargets.forEach((bloco) => {
      // Sem `toggle: false` o Bootstrap alterna o bloco ao criar a instância.
      const collapse = bootstrap.Collapse.getOrCreateInstance(bloco, { toggle: false });

      if (abrir) {
        collapse.show();
      } else {
        collapse.hide();
      }
    });
  }

  sincronizar() {
    const proximaAcaoAbre = !this.todosAbertos;

    this.rotuloTarget.textContent = proximaAcaoAbre ? "Expandir tudo" : "Recolher tudo";
    this.iconeTarget.classList.toggle("bi-chevron-expand", proximaAcaoAbre);
    this.iconeTarget.classList.toggle("bi-chevron-contract", !proximaAcaoAbre);
  }

  get todosAbertos() {
    return this.blocoTargets.every((bloco) => bloco.classList.contains("show"));
  }
}
